import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { TimeSettingsViewImpl } from './timesettingsview';
import { TimeSettingsCSSStyleImpl } from './timesettingscss';
import { TimeBasedSettingBaseDtoImpl } from '../../../../../core/dto/timebasedsetting/timebasedsettingbasedto';
import { DropDownDto } from 'src/com/sixdee/crbtportal/core/dto/dropdown/dropdowndto';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface TimeSettingsComponentProps extends UIComponentProps
{
  
}

export interface TimeSettingsComponentState extends UIComponentState
{
    repeatInterval: string;
    callerSetting: string;
    dropDownList:DropDownDto[];
}

export interface TimeSettingsComponentHandler extends UIComponentHandler
{
    onRepeatIntervalSelected(repeatInterval: string): void;
    onTimeSettingSelected(callerSetting: string): void;
}

export class TimeSettingsComponent extends UIComponentImpl<TimeSettingsComponentProps, TimeSettingsComponentState, UIDataModel> implements
TimeSettingsComponentHandler
{
    constructor(props: TimeSettingsComponentProps)
    {
        super(props);

        this.state = {callerSetting: "",
            repeatInterval: props.context.getResources().getString(Strings.none), dropDownList:[]};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TimeSettingsViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TimeSettingsCSSStyleImpl(applicationContext);
    }

    onTimeSettingSelected(callerSetting: string): void {
        this.setState({callerSetting: callerSetting});
    }

    getCallerSettings():string{
       return  this.state.callerSetting;
    }

    getIntervalLength():number
    {
      return  (this.getView() as TimeSettingsViewImpl).getIntervalListLength();
    }
    getCallerData(timeBasedSettingForAllCallersDto: TimeBasedSettingBaseDtoImpl)
    {
        (this.getView() as TimeSettingsViewImpl).getAllCallerData(timeBasedSettingForAllCallersDto);
    }

    // getSpecialCallerData(timeBasedSettingForAllCallersDto: TimeBasedSettingForSpecificCallerDtoImpl)
    // {
    //     (this.getView() as TimeSettingsViewImpl).getSpecialCallerData(timeBasedSettingForAllCallersDto);
    // }

    // getCallerGroupData(timeBasedSettingForAllCallersDto: TimeBasedSettingForCallersGroupDtoImpl)
    // {
    //     (this.getView() as TimeSettingsViewImpl).getCallerGroupData(timeBasedSettingForAllCallersDto);
    // }

    onRepeatIntervalSelected(repeatInterval: string): void 
    {
        console.log("------onRepeat: " + this.state.callerSetting);
       this.setState({repeatInterval: repeatInterval});
    }

    // onSelectTimeFromDate(time: string): void {
    //    this.setState({selectTimeFromDate: time});
    // }
    // onSelectTimeToDate(time: string): void {
    //     this.setState({selectTimeToDate: time});
    // }
    // onSelectDateTimeFromDate(time: string): void {
    //     this.setState({selectDateTimeFromDate: time});
    // }
    // onSelectDateTimeToDate(time: string): void {
    //     this.setState({selectDateTimeToDate: time});
    // }

    // onFailure(feature: APIFeatures, description: string, data: any): void 
    // {
       
    //     (this.getView() as TimeSettingsViewImpl).showPopup(this.getContext().getResources().getString(Strings.delete),description,AlertType.ERROR);
    // }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/timesettings/timesettingscomponent.tsx